import { render } from "./History.vue?vue&type=template&id=42ab531a&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=42ab531a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42ab531a"

export default script